import { render } from "./CompanyBonusesPage.vue?vue&type=template&id=d382854c&scoped=true"
import script from "./CompanyBonusesPage.vue?vue&type=script&lang=js"
export * from "./CompanyBonusesPage.vue?vue&type=script&lang=js"

import "./CompanyBonusesPage.vue?vue&type=style&index=0&id=d382854c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d382854c"]])

export default __exports__